export enum ContactServiceAction {
  SUBMIT_CONTACT_SERVICE = 'SUBMIT_CONTACT_SERVICE',
}

export const ContactServiceScope = 'contact-service';
